import React from 'react';

// import must be here so styles are at the top of generated CSS
import '../styles/global.module.css';

import Layout   from '../components/layout';
import SEO      from '../components/seo';
import { i18n } from '../components/i18n';

import Page1 from '../components/page-1';
import Page2 from '../components/page-2';
import Page3 from '../components/page-3';
import Page4 from '../components/page-4';

import Modal from '../components/modal';

import PageContext from '../components/context';

import { setStrings } from '../components/i18n';

const pages = {
    1 : Page1,
    2 : Page2,
    3 : Page3,
    4 : Page4
};

export default class App extends React.Component {
    constructor({ pageContext }) {
        super();

        setStrings(pageContext.strings, pageContext.debug.i18n);

        this.lang     = pageContext.lang;
        this.metatags = pageContext.metatags;
        this.part     = pageContext.part;
        this.navs     = pageContext.navs;
        this.gw2Url   = pageContext.gw2Url;
        this.debug    = pageContext.debug;

        this.state = {
            modalVisible : false,
            modalContent : null
        };

        this.openModal                  = this.openModal.bind(this);
        this.handleExitModal            = this.handleExitModal.bind(this);
        this.handleClickingOutsideModal = this.handleClickingOutsideModal.bind(this);
        this.handleEscapingModal        = this.handleEscapingModal.bind(this);
    }

    openModal(content) {
        this.setState({ modalVisible : true, modalContent : content });
    }

    handleClickingOutsideModal(e) {
        if (e.target === e.currentTarget) {
            return this.handleExitModal();
        }
    }

    handleEscapingModal(e) {
        if (e.key === 'Escape') {
            return this.handleExitModal();
        }
    }

    handleExitModal() {
        this.setState({ modalVisible : false, modalContent : null });
    }

    render() {
        const { lang, metatags, part, navs, gw2Url, debug } = this;
        const Page                                          = pages[part];
        const { modalVisible, modalContent }                = this.state;

        return (
            <PageContext.Provider value={{ part, lang, gw2Url, openModal : this.openModal }}>
                <Layout navs={navs} debug={debug}>
                    <SEO title={i18n('title', { md : false })} lang={lang} metatags={metatags} />
                    <Page />
                    <Modal
                        visible={modalVisible}
                        content={modalContent}
                        handleExitModal={this.handleExitModal}
                        handleClickingOutsideModal={this.handleClickingOutsideModal}
                        handleEscapingModal={this.handleEscapingModal}
                    />

                </Layout>
            </PageContext.Provider>
        );
    }
}
